"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArconBarrierAbilityHandler = exports.ArconBarrierActorAbilityFactory = exports.ArconBarrierAbilityArgs = void 0;
const ts_essentials_1 = require("ts-essentials");
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const enums_1 = require("../../core/enums");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class ArconBarrierAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.ArconBarrier;
        this.__typeName = "ArconBarrier";
    }
}
exports.ArconBarrierAbilityArgs = ArconBarrierAbilityArgs;
let ArconBarrierActorAbilityFactory = class ArconBarrierActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("ArconBarrier", "AllAllies", 4);
    }
};
ArconBarrierActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("ArconBarrier")
], ArconBarrierActorAbilityFactory);
exports.ArconBarrierActorAbilityFactory = ArconBarrierActorAbilityFactory;
let ArconBarrierAbilityHandler = class ArconBarrierAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const allies = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies);
        container.applyAbilityAnimation({
            sequence,
            animatedId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            onAnimated(sequence) {
                allies.forEach(ally => {
                    container.applyBuffs({
                        sequence,
                        creatorId: ability.invokerId,
                        targetId: ally,
                        effects: [
                            {
                                duration: Duration_1.Duration.Turns(4),
                                effect: new core_1.DamageAbsorbEffectArgs({
                                    [enums_1.DamageType.All]: container.getPercentOfBaseHealth(ally, 25)
                                })
                            }
                        ],
                        // The tempests animation has its own custom shield built into it
                        onApplied: ally === ability.invokerId ? ts_essentials_1.noop
                            : sequence => sequence.push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(ally, "feet", "behind"), "BlueMagicCircle"))
                    });
                });
            }
        });
    }
};
ArconBarrierAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.ArconBarrier)
], ArconBarrierAbilityHandler);
exports.ArconBarrierAbilityHandler = ArconBarrierAbilityHandler;
